export default __webpack_public_path__ + "static/media/bottom_image.52ed785c.png";